export const PAGES = {
  upcoming: 'upcoming',
  onTheWay: 'on-the-way',
  delivered: 'delivered',
};
